/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminthreads_Title1Inputs */

const zh_adminthreads_title1 = /** @type {(inputs: Adminthreads_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对话管理`)
};

const en_adminthreads_title1 = /** @type {(inputs: Adminthreads_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation Management`)
};

const es_adminthreads_title1 = /** @type {(inputs: Adminthreads_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de conversaciones`)
};

/**
* | output |
* | --- |
* | "Conversation Management" |
*
* @param {Adminthreads_Title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminthreads_title1 = /** @type {((inputs?: Adminthreads_Title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminthreads_Title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminthreads_title1(inputs)
	if (locale === "en") return en_adminthreads_title1(inputs)
	return es_adminthreads_title1(inputs)
});
export { adminthreads_title1 as "adminThreads_title" }